/*
 * Form
 */

(function ($) {

    /* acceptance */
    var wpcf7_acceptance = $('.wpcf7-acceptance');
    var wpcf7_submit = $('.wpcf7-submit');
    if (wpcf7_acceptance.length > 0) {
        if (wpcf7_submit.prop('disabled', true))
            $('.form_btn_group .btn-input').addClass('_disabled');

        var btn_acceptance = wpcf7_acceptance.find('input');
        btn_acceptance.prop('checked', false);
        btn_acceptance.on('click', function () {
            $('.form_btn_group .btn-input').toggleClass('_disabled');
        });
    }

    /* privacy scrollbar */
    if ($('.form_privacy__scroll').length > 0) {
        var ps = new PerfectScrollbar('.form_privacy__scroll');
        ps.update();
    }

    /* zipcode to address */
    if ($('#zipcode').length > 0) {
        $('#zipcode').zip2addr({
            addr: '#address'
        });
    }

    /* free text placeholder */
    var free_text = jQuery('.wpcf7-free-text');
    if (free_text.length > 0) {
        if (jQuery('.reserve').length > 0 && jQuery('.page-id-149').length > 0) {
            jQuery('.checkbox_group1a input[name="_wpcf7_free_text_field_reason"]').attr('placeholder', '熱が37.５°あります');
        }
    }

    /* questionaire05 */
    var radio_ques05 = jQuery('._ques05 ._list > .wpcf7-form-control-wrap:first-child input[type="checkbox"]');
    if (radio_ques05.length > 0) {
        if (radio_ques05.prop('checked', false))
            jQuery('#field_questionnaire05 input[type="text"]').prop('disabled', true);

        jQuery('._ques05 ._list > .wpcf7-form-control-wrap input[type="checkbox"]').on('change', function () {
            if (radio_ques05.prop('checked'))
                jQuery('#field_questionnaire05 input[type="text"]').prop('disabled', false);
            else
                jQuery('#field_questionnaire05 input[type="text"]').prop('disabled', true);
        });
    }

    if (jQuery('#txt_check01').length > 0 && jQuery('#txt_check01').text() != 'はい') {
        jQuery('#txt_check02').remove();
    }
})(jQuery);